(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digital-sanctuary"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-countdown]');
    if (!root) return;

    var target = new Date(root.getAttribute('data-countdown').replace(' ', 'T')).getTime();
    if (isNaN(target)) return;

    var timerEl = root.querySelector('[data-timer]');
    var expiredEl = root.querySelector('[data-expired]');
    var ddEl = root.querySelector('[data-dd]');
    var hhEl = root.querySelector('[data-hh]');
    var mmEl = root.querySelector('[data-mm]');
    var ssEl = root.querySelector('[data-ss]');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        if (timerEl) timerEl.hidden = true;
        if (root.querySelector('[data-label]')) root.querySelector('[data-label]').hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        clearInterval(interval);
        return;
      }
      ddEl.textContent = Math.floor(diff / 86400000);
      hhEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      mmEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      ssEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    var interval = setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const popup = document.getElementById('emailPopup');
    const closeBtn = popup?.querySelector('.email-popup__close');
    const dismissKey = 'bbt-popup-dismissed';

    function showPopup() {
      if (!localStorage.getItem(dismissKey)) {
        setTimeout(() => {
          popup.classList.add('show');
        }, 4000);
      }
    }

    function closePopup() {
      popup.classList.remove('show');
      localStorage.setItem(dismissKey, 'true');
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 0 && !localStorage.getItem(dismissKey)) {
        showPopup();
      }
    });

    showPopup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('header-mobile-menu');

    if (!toggle || !menu) return;

    function closeMenu() {
      toggle.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
    }

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      menu.classList.toggle('is-open', !isOpen);
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 768) closeMenu();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const gallery = document.getElementById('product-gallery-{{ section.id }}');
    const thumbs = document.querySelectorAll('.product__gallery-thumb');
    const dots = document.querySelectorAll('.product__gallery-dot');
    const slides = document.querySelectorAll('.product__gallery-slide');

    function goToSlide(targetId) {
      const targetSlide = document.getElementById(targetId);
      if (targetSlide) {
        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    function setActive(targetId) {
      thumbs.forEach(function (t) {
        t.classList.toggle('product__gallery-thumb--active', t.getAttribute('data-target') === targetId);
      });
      dots.forEach(function (d) {
        d.classList.toggle('product__gallery-dot--active', d.getAttribute('data-target') === targetId);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const targetId = thumb.getAttribute('data-target');
        goToSlide(targetId);
        setActive(targetId);
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const targetId = dot.getAttribute('data-target');
        goToSlide(targetId);
        setActive(targetId);
      });
    });

    if (gallery && slides.length && 'IntersectionObserver' in window) {
      const slideObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.id);
          });
        },
        { root: gallery, threshold: 0.6 }
      );
      slides.forEach(function (slide) { slideObserver.observe(slide); });
    }

    const qtyInputs = document.querySelectorAll('.product__quantity-input');
    document.querySelectorAll('.product__quantity-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const wrapper = btn.closest('.product__quantity-wrapper');
        const input = wrapper.querySelector('.product__quantity-input');
        const action = btn.getAttribute('data-action');
        const val = parseInt(input.value, 10) || 1;
        if (action === 'increment') {
          input.value = val + 1;
        } else if (action === 'decrement' && val > 1) {
          input.value = val - 1;
        }
      });
    });

    const stickyBar = document.querySelector('[data-sticky-bar]');
    const mainAddToCart = document.querySelector('.product__add-to-cart');
    const stickyAddToCart = document.querySelector('[data-sticky-bar-add]');

    if (stickyBar && mainAddToCart && 'IntersectionObserver' in window) {
      const barObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.classList.toggle('is-visible', scrolledPast);
            stickyBar.hidden = !scrolledPast;
          });
        },
        { threshold: 0 }
      );
      barObserver.observe(mainAddToCart);
    }

    if (stickyAddToCart && mainAddToCart) {
      stickyAddToCart.addEventListener('click', function () {
        mainAddToCart.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanctuary"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var intro = document.getElementById('sanctuary-intro');
    var main = document.getElementById('sanctuary-main');
    if (!intro) return;

    function revealMain() {
      if (!main) return;
      main.removeAttribute('aria-hidden');
      main.removeAttribute('inert');
    }

    if (document.documentElement.classList.contains('sanctuary-skip-intro')) {
      intro.style.display = 'none';
      revealMain();
      return;
    }

    if (main) {
      main.setAttribute('aria-hidden', 'true');
      main.setAttribute('inert', '');
    }
    document.body.style.overflow = 'hidden';
    intro.focus();

    var lines = intro.querySelectorAll('[data-intro-line]');
    var prompt = intro.querySelector('[data-intro-prompt]');
    var lineStagger = 800;
    var lineDuration = 1100;

    lines.forEach(function (line, i) {
      setTimeout(function () {
        line.classList.add('is-visible');
      }, i * lineStagger);
    });

    setTimeout(function () {
      if (prompt) prompt.classList.add('is-visible');
    }, (lines.length - 1) * lineStagger + lineDuration);

    var dismissed = false;

    function dismiss() {
      if (dismissed) return;
      dismissed = true;
      intro.classList.add('is-hidden');
      document.body.style.overflow = '';
      revealMain();
      setTimeout(function () {
        intro.style.display = 'none';
        if (main) main.focus();
      }, 800);
    }

    intro.addEventListener('click', dismiss);
    intro.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
        e.preventDefault();
        dismiss();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-deck"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('[data-carousel]');

    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var slides = carousel.querySelectorAll('[data-carousel-slide]');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var dotsContainer = carousel.querySelector('[data-carousel-dots]');
      var thumbs = carousel.querySelectorAll('[data-carousel-thumb]');

      if (!track || slides.length === 0) return;

      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.classList.add('the-deck__carousel-dot');
        dot.setAttribute('aria-label', 'Go to image ' + (index + 1));
        if (index === 0) dot.classList.add('active');
        dot.addEventListener('click', function () {
          goToSlide(index);
        });
        dotsContainer.appendChild(dot);
      });

      var dots = carousel.querySelectorAll('.the-deck__carousel-dot');

      function slideStep() {
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0');
        return slides[0].getBoundingClientRect().width + gap;
      }

      function currentIndex() {
        return Math.round(track.scrollLeft / slideStep());
      }

      function goToSlide(index) {
        var clamped = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: clamped * slideStep(), behavior: 'smooth' });
      }

      function updateIndicators() {
        var index = currentIndex();
        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === index);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('active', i === index);
        });
      }

      var scrollTimeout;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateIndicators, 80);
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToSlide(currentIndex() - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToSlide(currentIndex() + 1);
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goToSlide(parseInt(thumb.dataset.index, 10) || 0);
        });
      });

      window.addEventListener('resize', updateIndicators);
    });

    document.querySelectorAll('[data-qty]').forEach(function (qty) {
      var input = qty.querySelector('[data-qty-input]');
      var decreaseBtn = qty.querySelector('[data-qty-decrease]');
      var increaseBtn = qty.querySelector('[data-qty-increase]');

      if (!input) return;

      decreaseBtn.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, value - 1);
      });

      increaseBtn.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = value + 1;
      });

      input.addEventListener('change', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, value);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
